module.exports = {
    "source_code": "HLXEMS",
    "site_id": "discovergrad.agnesscott.edu",
    "title": "Agnes Scott College",
    "tfn": "",
    "url": "https://discovergrad.agnesscott.edu",
    "gtm_code": "GTM-W75P53VS",
}